import { useEffect } from 'react';
import useSelector, { useDispatch } from 'components/Booking-new/hooks';
import isObjectNotEmpty from 'utils/isObjectNotEmpty';
import { addWaitlistIntoBookingSteps } from 'components/Booking-new/actions';
import stepTypes from 'components/Booking-new/modules/Steps/types';

export const useWaitlistEffector = (showTimeSlots, isBookingFunnel) => {
  const dispatch = useDispatch();

  const { results } = useSelector(state => ({
    stepPersonalData: state?.userData?.[stepTypes.personalData],
  }));

  const shouldPersonalDataCollected = !isObjectNotEmpty(results?.stepPersonalData);
  useEffect(() => {
    if (showTimeSlots && isBookingFunnel) dispatch(addWaitlistIntoBookingSteps());
  }, [showTimeSlots]);

  return {
    shouldPersonalDataCollected,
  };
};
